import styled from 'styled-components';
import {FormControl, Select, TextField} from '@mui/material';
import {DatePicker} from "@mui/x-date-pickers";
import {tokens} from "../../../../../theme";

export const FiltersFieldsWrapper = styled.div`
    padding: 16px 32px 20px;
    border: 1px solid ${({theme}) => theme.palette.divider};
    border-radius: ${tokens.radius.md};
    background-color: ${({theme}) => theme.palette.background.dropzone};
    width: 100%;
    box-sizing: border-box;
`;

export const FiltersTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const FiltersLabel = styled.span`
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.medium};
    color: ${({theme}) => theme.palette.text.hint};
    letter-spacing: 0.8px;
`;

export const StyledTextField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            border-radius: ${tokens.radius.md};
            background: ${({theme}) => theme.palette.background.input};
            font-size: ${tokens.fontSize.base};

            &:hover .MuiOutlinedInput-notchedOutline {
                border-color: ${({theme}) => theme.buttonTokens.secondary.hoverBorder};
                box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
            }

            &.Mui-focused .MuiOutlinedInput-notchedOutline {
                border: 2px solid ${({theme}) => theme.buttonTokens.secondary.focusRing};
                box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
            }
        }

        .MuiInputLabel-root {
            font-size: ${tokens.fontSize.base};
            color: ${({theme}) => theme.palette.text.placeholder};

            &.Mui-focused {
                color: ${({theme}) => theme.buttonTokens.secondary.focusRing};
            }
        }
    }
`;

export const StyledSelect = styled(Select)`
    && {
        border-radius: ${tokens.radius.md};
        background: ${({theme}) => theme.palette.background.input};
        font-size: ${tokens.fontSize.base};

        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${({theme}) => theme.buttonTokens.secondary.hoverBorder};
            box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
        }

        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border: 2px solid ${({theme}) => theme.buttonTokens.secondary.focusRing};
            box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
        }
    }
`;

export const StyledFormControl = styled(FormControl)`
    && {
        .MuiInputLabel-root {
            font-size: ${tokens.fontSize.base};
            color: ${({theme}) => theme.palette.text.placeholder};

            &.Mui-focused {
                color: ${({theme}) => theme.buttonTokens.secondary.focusRing};
            }
        }
    }
`;

export const StyledDatePicker = styled(DatePicker)`
    && {
        .MuiOutlinedInput-root {
            border-radius: ${tokens.radius.md};
            background: ${({theme}) => theme.palette.background.input};
            font-size: ${tokens.fontSize.base};

            &:hover .MuiOutlinedInput-notchedOutline {
                border-color: ${({theme}) => theme.buttonTokens.secondary.hoverBorder};
                box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
            }

            &.Mui-focused .MuiOutlinedInput-notchedOutline {
                border: 2px solid ${({theme}) => theme.buttonTokens.secondary.focusRing};
                box-shadow: 0 0 4px 1px ${({theme}) => theme.buttonTokens.secondary.focusRingShadow};
            }
        }

        .MuiInputLabel-root {
            font-size: ${tokens.fontSize.base};
            color: ${({theme}) => theme.palette.text.placeholder};

            &.Mui-focused {
                color: ${({theme}) => theme.buttonTokens.secondary.focusRing};
            }
        }
    }
` as typeof DatePicker;